import React from "react";
import { Link, withRouter } from 'react-router-dom'
import Aux from "../AuxFunctions";
import LikeOutlineIcon from "mdi-react/HeartOutlineIcon"
import LikeFilledIcon from "mdi-react/HeartIcon"
/* import CommentOutlineIcon from "mdi-react/CommentOutlineIcon"
import CommentFilledIcon from "mdi-react/CommentIcon" */
import ShareOutlineIcon from "mdi-react/ShareOutlineIcon"
import "../../App.css"

import SharePostModal from "../Utilities/ShareModal";
import Fire from "../../config/Fire";
import NotLoggedIn from "../ErrorPages/NotLoggedIn";
import Colors from "../Colors";
import ImagePost from "../Utilities/ImagePost"
import Embed from 'react-embed';
import { Anchorme } from 'react-anchorme'
import PencilIcon from "mdi-react/PencilIcon";
import EditPostModal from "../../create/EditPostModal";

class RenderPost extends React.PureComponent {
   constructor(props) {
      super(props);
      this.state = {
         post: {
            likesCount: 0,
            commentCount: 0,
         },
         loading: true,
         openShareModal: false,
         openLoginModal: false,
         editModal: false,
         loadedLikes: false,
         loadingLike: false,
      }

      this.shareText = this.props.post ? this.props.post.text : ""
      this.shareImage = this.props.post ? this.props.post.image : ""
      this.shareCategory = this.props.post ? this.props.post.category : ""
      this.shareUrl = this.props.post ? 'https://richless.app/post/' + this.props.post.id : ""
   }

   componentDidMount() {
      try {
         if (this.props.post) {
            this.setState(prevState => ({
               post: {                   // object that we want to update
                  ...prevState.post,    // keep all other key-value pairs
                  ...this.props.post       // update the value of specific key
               }
            }))
            if (this.props.liked) {
               this.ChangeLike(true);
               this.getInfo(this.props.post.postid)
            } else {
               this.checkIfLiked(this.props.post.id);
            }
         } else if (this.props.comment) {
            this.getInfo(this.props.comment.postid);
            this.checkIfLiked(this.props.comment.postid);
         }
      } catch (error) {
         Aux.handleError(error)
      }
   }

   getInfo = async (id) => {
      try {
         var initialQuery = Fire.shared.firestore
            .collection('posts')
            .doc(id);

         let snapshot = await initialQuery.get();
         if (snapshot.exists) {
            let data = snapshot.data();
            data.id = snapshot.id;
            this.setState(prevState => ({
               post: {                   // object that we want to update
                  ...prevState.post,    // keep all other key-value pairs
                  ...data       // update the value of specific key
               }
            }))

            this.shareText = data.text
            this.shareImage = data.image ? data.image : ""
            this.shareCategory = data.category
            this.shareUrl = 'https://richless.app/post/' + data.id

         }
      } catch (error) {
         Aux.handleError(error)
      }
   }

   checkIfLiked = async (id) => {
      try {
         if (!Fire.shared.uid) {
            return;
         }
         this.setState({loadingIfLiked: true})
         await Fire.shared.firestore.collection(`users/${Fire.shared.uid}/likes`)
            .where("postid", "==", id).get().then(data => {
               if (!data.empty) {
                  this.ChangeLike(true);
               }
               this.setState({loadedLikes: true})
            })
      } catch (error) {
         Aux.handleError(error);
      }
   }

   ChangeLike = (liked) => {
      if (!Fire.shared.uid) {
         return;
      }
      try {

         this.setState(prevState => ({
            post: {                   // object that we want to update
               ...prevState.post,
               liked: liked,
            }
         }))
      } catch (error) {
         Aux.handleError(error);
      }
   }

   ChangeToogleLike = (liked) => {
      if (!Fire.shared.uid) {
         return;
      }
      try {
         this.setState(prevState => ({
            post: {                   // object that we want to update
               ...prevState.post,
               liked: liked,
               likesCount: liked ? prevState.post.likesCount + 1 : prevState.post.likesCount - 1,
            }
         }))
      } catch (error) {
         Aux.handleError(error);
      }
   }
   
   ToogleLikePost = async (e) => {
      e.stopPropagation()
      if (!Fire.shared.uid) {
         this.ToggleLoginModal();
         return;
      }

      if(!this.state.loadedLikes){
         return;
      }
      
      if(this.state.loadingLike){
         return
      }

      try {
         this.setState({loadingLike: true})
         
         if (this.state.post.liked) {
            this.ChangeToogleLike(false);
         } else {
            this.ChangeToogleLike(true);
         }
         await Fire.shared.toogleLikePost(this.state.post,);
         this.setState({loadingLike: false})
         
      } catch (error) {
         Aux.handleError(error);
         this.setState({loadingLike: false})
      }
   }

   toggleShareModal = () => {
      this.setState({
         openShareModal: !this.state.openShareModal
      });
   }

   ToggleLoginModal = () => {
      this.setState({
         openLoginModal: !this.state.openLoginModal
      });
   }

   goToPost = () => {
      //this.props.history.push(`/message/${this.props.message.id}`,{user:this.state.user})
      this.props.history.push({pathname: `/post/${this.state.post.id}`,
      state: { post: this.state.post, loadedLikes: this.state.loadedLikes }})
  }

   /* goToPost = (e) => {
      this.props.history.push(`/post/${this.state.post.id}`)
   } */

   getRoundCoins = (coins) => {
      try {
         if(coins < 0)
            return 0
         else
            return Math.round( coins * 10 + Number.EPSILON ) / 10
      } catch (error) {
          Aux.handleError(error)
      }
   }

   render() {
      const isMyPost = this.state.post.uid === Fire.shared.uid
      return (

         <div className="single-post full-shadow" style={{
            /* width: this.props.styles.showSidebar ? "50%" : "80%", */
            padding: 20,
            borderRadius: 9,
            /*             boxShadow: "0px 0px 5px 0px rgba(0,0,0,.15)",
                        WebkitBoxShadow: "0px 0px 5px 0px rgba(0,0,0,.15)",
                        MozBoxShadow: "0px 0px 5px 0px rgba(0,0,0,.15)",  */
            // maxWidth: 500,
            margin: "25px 10px",
         }} onClick={this.goToPost}>
            <SharePostModal active={this.state.openShareModal} onClose={this.toggleShareModal} title="Share this post" text={this.shareText} url={this.shareUrl} image={this.shareImage} hashtag={this.shareCategory}></SharePostModal>
            <NotLoggedIn active={this.state.openLoginModal} onClose={this.toggleLoginModal}></NotLoggedIn>
            {isMyPost ? <EditPostModal  active={this.state.editModal} onClose={() => this.setState({ editModal: false })} post={this.state.post}></EditPostModal>: null}
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}> 
               <div style={{display:"flex", alignItems:"center", overflow:"hidden"}}>
                  {this.state.post.hide ?
                     <div style={{display:"flex", alignItems:"center", overflow:"hidden" }}>
                        {Aux.showHidden(50)}
                        <div style={{ display: "flex", flexDirection: "column", overflow:"hidden" }}>
                                 <span style={{ /* color: "#ffa100", */ color: Colors.softText, fontWeight: "bold", marginLeft: 10, display:"flex" }}>
                                    Anonymous
                                 </span>
                              {this.state.post.hashtag ?
                                 <Link style={{ marginLeft: 10, textDecoration: "none", color: Colors.middleText, overflow:"hidden", textOverflow:"ellipsis" }} to={"/hashtag/" + this.state.post.hashtag}>
                                    #{this.state.post.hashtag}
                                 </Link> : null}
                        </div>
                        {/*<h3 style={{ alignSelf: "center", color: Colors.softText, marginLeft: 10 }}>
                           Anonymous
                        </h3> */}
                     </div>
                     :
                     <div style={{overflow:"hidden"}}>
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginLeft: 10, overflow:"hidden" }}>
                           <Link onClick={(e)=> e.stopPropagation()} to={`/user/${this.state.post.username}`} style={{ textDecoration: "none" }}>
                              {Aux.showAvatar(50, this.state.post.avatar, this.state.post.username || "Unknown")}
                           </Link>
                           <div style={{ display: "flex", flexDirection: "column", overflow:"hidden" }}>
                              <Link onClick={(e)=> e.stopPropagation()} to={`/user/${this.state.post.username}`} style={{ textDecoration: "none", overflow:"hidden", textOverflow:"ellipsis"   }}>
                                 <span className="text-hover" style={{ /* color: "#ffa100", */ color: Colors.darkText, fontWeight: "bold", marginLeft: 10, overflow:"hidden", display:"flex"}}>
                                    {this.state.post.username || "Unknown"}
                                 </span>
                              </Link>
                              {this.state.post.hashtag ?
                                 <Link onClick={(e)=> e.stopPropagation()} style={{ marginLeft: 10, textDecoration: "none", color: Colors.middleText, overflow:"hidden", textOverflow:"ellipsis" }} to={"/hashtag/" + this.state.post.hashtag}>
                                   <span className="text-hover" style={{overflow:"hidden"}}> #{this.state.post.hashtag}</span>
                                 </Link> : null}
                           </div>
                        </div>
                     </div>
                  }
                  {isMyPost ? 
                     <div onClick={(e) => {this.setState({editModal:true}); e.stopPropagation()}} className="text-hover" style={{display:"flex", alignItems:"center", backgroundColor:Colors.softText, padding:"4px 10px", borderRadius:10, marginLeft:10}}> 
                        <span  style={{color:"white", marginRight:5}}>Edit</span>
                        <PencilIcon size={16} color={"white"}></PencilIcon>
                     </div> : null}
               </div>
               <h3 style={{ marginRight: 10, marginLeft: 10 }}>{this.getRoundCoins(this.state.post.coins || 0)}$</h3>
            </div>

            {/* <Link to={`/post/${this.state.post.id}`} style={{ textDecoration: "none", }}> */}
               <div onClick={this.goToPost} style={{ display: "flex", justifyContent: "flex-start", margin: 0 }}>
                  {this.state.post.text ?
                  <span style={{ marginTop: 10, marginLeft: 10, color: "black", textAlign: "start", whiteSpace: "break-spaces" }}>
                  <Anchorme onClick={e => e.stopPropagation()} target="_blank" rel="noreferrer noopener">
                     {this.state.post.text}
                   </Anchorme></span>  
                   : null}
               </div>
            {/* </Link> */}
            {this.state.post.website ?
            <div style={{margin:"10px 0"}}>
               {/* <div style={{ display: "flex", alignItems: "center" }}>
                  <LinkIcon size={20} style={{ margin: "0 10px" }}></LinkIcon>
                  <a href={"http://" + this.state.post.website} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()}
                     style={{ marginLeft: 10, overflowWrap: "anywhere" }}
                  >
                     {this.state.post.website}
                  </a>
               </div> */}
               
               <Embed url={this.state.post.website} />
               </div>
               : null}
            {this.state.post.image ?
               <Link to={`/post/${this.state.post.id}`} style={{ textDecoration: "none" }}>
                  <ImagePost image={this.state.post.image} style={{ width: "100%", borderRadius: 20, margin: "10px 0", }}></ImagePost>
               </Link> : null}

            <div style={{ display: "flex", flexDirection: "row", marginLeft: 10, marginTop: 10, justifyContent: "space-between" }} >
               <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                  <div style={{ color: "#ccc", display: "flex", flexDirection: "row", alignItems: "center" }} onClick={this.ToogleLikePost}>
                     {this.state.post.liked ?
                        <LikeFilledIcon className="post-like" size="30" color={Colors.mainColorText} style={{ marginRight: 7 }}></LikeFilledIcon>
                        :
                        <LikeOutlineIcon className="post-like" size="30" color={Colors.softText} style={{ marginRight: 7 }}></LikeOutlineIcon>
                     }
                     <span>{this.state.post.likesCount || 0 } likes</span>

                  </div>
                  <Link to={`/post/${this.state.post.id}`} style={{ textDecoration: "none", }}>
                     <div style={{ color: "#ccc", marginLeft: 20, display: "flex", flexDirection: "row", alignItems: "center" }}>
                        {/* <CommentOutlineIcon className="post-like" size="28" style={{ marginRight: 10 }}></CommentOutlineIcon> */}
                        <span>{this.state.post.commentCount || 0} comments</span>
                     </div>
                  </Link>
               </div>
               <div style={{ color: "#ccc", alignItems: "center", display: "flex" }} onClick={e => {e.stopPropagation();this.toggleShareModal()}}>
                  <ShareOutlineIcon className="post-like" size="30" style={{ marginRight: 10 }}></ShareOutlineIcon>
               </div>
            </div>
         </div>
      );
   }
}

export default withRouter(RenderPost);